import _ from 'lodash';
import projectsModel from '$$projectModel';
import { Gantt } from '../../libs/dhtmlxgantt8/dhtmlxgantt';
import setWorkTime from './setWorkTime';
import setCustomWorkTime from './setCustomWorkTime';

export default function (ganttId) {
  const projectConfig = projectsModel.getProjectConfig(+ganttId);

  if (!projectConfig) {
    return;
  }

  const config = {
    auto_scheduling_initial: false,
    work_time: true,
    duration_unit: projectConfig.duration_unit,
    inherit_calendar: true,
    date_format: '%Y-%m-%d %H:%i',
    correct_work_time: true,
    types: {
      project: 'project',
      milestone: 'milestone',
      task: 'task',
    },
    auto_scheduling: projectConfig.auto_scheduling,
    estimation_mode: projectConfig.estimation_mode,
    apply_resource_calendar: projectConfig.apply_resource_calendar,
    progress: projectConfig.progress,
    resource_loading_type: projectConfig.resource_loading_type,
  };
  const workDays = new Array(7).fill(false);

  projectConfig.durationData.showDay.forEach(dayIndex => {
    if (dayIndex === 7) {
      workDays[0] = true; // sunday should be first
    } else {
      workDays[dayIndex] = true;
    }
  });

  let instance = Gantt.getGanttInstance(config);

  instance.addCalendar({
    id: +ganttId,
    worktime: {
      hours: projectConfig.durationData.showTime,
      days: workDays,
    },
  });

  setWorkTime(instance, projectConfig.durationData);
  setCustomWorkTime(instance, +ganttId);

  const result = _.cloneDeep(instance.getCalendar(+ganttId).getConfig());

  instance.destructor();
  instance = null;

  return result;
}
